<template>
  <div class="app-header-mobile">
    <div class="app-header-mobile__logo">
      <Logo />
    </div>
  </div>
</template>

<script>
import Logo from '../logo';

export default {
  components: { Logo },
};
</script>

<style lang="scss" scoped>
.app-header-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 34px 56px 26px;
  background: linear-gradient(180deg, rgba(202, 221, 252, 0.7) 0%, rgba(202, 221, 252, 0) 100%);
  backdrop-filter: blur(0px);
}
</style>
